module.exports = __webpack_public_path__ + "img/logo_white.edad72ca.png";